type CaptureProps = Record<string, unknown>;
type PostHogLike = {
  capture: (event: string, props?: CaptureProps) => void;
  get_distinct_id?: () => string;
  has_opted_out_capturing?: () => boolean;
};
/** Instance PostHogProvider parks on window after idle-init. null until loaded. */
export function getPostHog(): PostHogLike | null {
  if (typeof window === 'undefined') return null;
  return (window as unknown as { posthog?: PostHogLike }).posthog ?? null;
}
/** Fire-and-forget capture. No-ops if posthog isn't loaded (posthog enforces opt-out itself). */
export function captureEvent(event: string, properties?: CaptureProps): void {
  const ph = getPostHog();
  if (!ph || typeof ph.capture !== 'function') return;
  try { ph.capture(event, properties); } catch { /* ignore */ }
}
/** Landing's anonymous distinct_id (for closed-loop reference_id). undefined until loaded. */
export function getDistinctId(): string | undefined {
  const ph = getPostHog();
  try { return ph?.get_distinct_id?.(); } catch { return undefined; }
}
